import { Button } from "components/atoms";
import { Form } from "components/organisms";
import {
  userFormInitialValues,
} from "components/organisms/forms/client-user/ClientUserForm";
import { FormikHelpers } from "formik";
import { useMutateOptions } from "hooks";
import { useTranslation } from "react-i18next";
import { PiUserPlus, PiX } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useRegisterClientUser } from "services/clientUserManagment";
import { IRegisterUserForm } from "services/clientUserManagment/types"
import { BUTTON_VARIANT } from "types/components/button/button.interface";

const CreateClientUsers = () => {
  const { mutateAsync, isPending } = useRegisterClientUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const mutateOptions = useMutateOptions<IRegisterUserForm>();

  const i18nextPrefix = "user";

  const handlePostUser = async (
    values: IRegisterUserForm,
    helpers: FormikHelpers<IRegisterUserForm>
  ) => {
    await mutateAsync(values, {
      ...mutateOptions(helpers),
      onSuccess: ({ id }) => {
        navigate(`/client-users/${id}`);
      },
    });
  };
  
  return (
    <Form.ClientUser
      i18nextPrefix={i18nextPrefix}
      initialValues={userFormInitialValues}
      onSubmit={handlePostUser}
      tittle={t("user.title.create")}
      disableTabs={[0]}
      customBackItem={
        <Button
          type="button"
          onlyIcon
          onClick={() => navigate("/client-users")}
        >
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type="submit" variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t("button.create")} />
          <Button.Icon icon={<PiUserPlus />} />
        </Button>
      }
    />
  );
};

export default CreateClientUsers;
